import { CircularProgress, DialogContent } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'

import {
  Modal,
  ModalActionButton,
  ModalCloseButton,
  ModalCloseIcon,
  ModalHeader,
  ModalTitle,
} from '../../../../../buy/checkout/modals/styled'

export interface InputTooLongModalProps {
  className?: string
  children: React.ReactNode
  handleClose(): void
  handleSubmit(): void
  loading?: boolean
  open: boolean
  region?: string
}

export const InputTooLongModal: React.FC<InputTooLongModalProps> = ({
  className,
  children,
  handleClose,
  handleSubmit,
  loading,
  open,
}) => {
  return (
    <Modal
      aria-describedby="scroll-dialog-description"
      aria-labelledby="scroll-dialog-title"
      className={className}
      fullWidth
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      <ModalTitle disableTypography id="scroll-dialog-title">
        <ModalHeader>INPUT RESTRICTIONS</ModalHeader>
        <ModalCloseIcon aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </ModalCloseIcon>
      </ModalTitle>
      <DialogContent dividers>
        {children}
        <ModalActionButton onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'PUBLISH CHANGES'}
        </ModalActionButton>
        <ModalCloseButton color="secondary" onClick={handleClose} variant="outlined">
          CONTINUE EDITING
        </ModalCloseButton>
      </DialogContent>
    </Modal>
  )
}
